import CommonUser from '../../../models/commonUser'
import CommonFile from '../../../models/commonFile'
export default class NoticeDetails {
    /**
     * @type {string}
     * @memberof NoticeDetails
     * @name 类型Id
     */
    public categoryId: string;
    /**
     * @type {string}
     * @memberof NoticeDetails
     * @name 类型名称
     */
    public categoryName: string;
    /**
     * @type {string}
     * @memberof NoticeDetails
     * @name 内容
     */
    public content: string;
    /**
     * @type {CommonFile[]}
     * @memberof NoticeDetails
     * @name 文件附件
     */
    public fileAttachments: CommonFile[];
    /**
     * @type {CommonFile[]}
     * @memberof NoticeDetails
     * @name 图片附件
     */
    public imageAttachments: CommonFile[];
    /**
     * @type {string}
     * @memberof NoticeDetails
     * @name 等级ID
     */
    public levelId: string;
    /**
     * @type {string}
     * @memberof NoticeDetails
     * @name 等级Name
     */
    public levelName: string;
    /**
     * @type {string}
     * @memberof NoticeDetails
     * @name 等级颜色
     */
    public levelColor: string;
    /**
     * @type {boolean}
     * @memberof NoticeDetails
     * @name 是否需要确认已读
     */
    public needReplayFlag: boolean;
    /**
     * @type {boolean}
     * @memberof NoticeDetails
     * @name 含有附件
     */
    public attachmentFlag: boolean;
    /**
     * @type {string}
     * @memberof NoticeDetails
     * @name 通知ID
     */
    public noticeId: string;
    /**
     * @type {boolean}
     * @memberof NoticeDetails
     * @name 已读标志
     */
    public readFlag: boolean;
    /**
     * @type {string}
     * @memberof NoticeDetails
     * @name 发送消息的部门ID
     */
    public sendOrgId: string;
    /**
     * @type {string}
     * @memberof NoticeDetails
     * @name 发送消息的部门名称
     */
    public sendOrgName: string;
    /**
     * @type {string}
     * @memberof NoticeDetails
     * @name 发送消息的部门时间
     */
    public sendTime: string;
    /**
     * @type {string}
     * @memberof NoticeDetails
     * @name 发送消息的部门时间
     */
    public title: string;
    /**
     * @type {CommonUser}
     * @memberof NoticeDetails
     * @name 发送人信息
     */
    public sendUser: CommonUser;
        /**
     * @type {string}
     * @memberof NoticeDetails
     * @name 回复内容
     */
    public answerContent: string;
    /**
     * @type {string}
     * @memberof NoticeDetails
     * @name 回复日期
     */
    public answerDate: string;
    /**
     * @type {boolean}
     * @memberof NoticeDetails
     * @name 是否需要回复
     */
    public needAnswerFlag: boolean;
    /**
     * @type {string}
     * @memberof NoticeDetails
     * @name 通知类型
     */
    public noticeType: string;
    /**
     * @type {boolean}
     * @memberof NoticeDetails
     * @name 表单填报
     */
    public needFormFlag: boolean;
    constructor({
        categoryId = '',
        categoryName = '',
        content = '',
        fileAttachments = [],
        imageAttachments = [],
        levelId = '',
        levelName = '',
        levelColor = '',
        needReplayFlag = true,
        attachmentFlag = true,
        noticeId = '',
        readFlag = true,
        sendOrgId = '',
        sendOrgName = '',
        sendTime = '',
        title = '',
        sendUser = new CommonUser(),
        answerContent = '',
        answerDate = '',
        needAnswerFlag = false,
        noticeType = '',
        needFormFlag = false
    } = {}) {
        this.categoryId = categoryId
        this.categoryName = categoryName
        this.content = content
        this.fileAttachments = fileAttachments
        this.imageAttachments = imageAttachments
        this.levelId = levelId
        this.levelName = levelName
        this.levelColor = levelColor
        this.needReplayFlag = needReplayFlag
        this.attachmentFlag = attachmentFlag
        this.noticeId = noticeId
        this.readFlag = readFlag
        this.sendOrgId = sendOrgId
        this.sendOrgName = sendOrgName
        this.sendTime = sendTime
        this.title = title
        this.sendUser = sendUser
        this.answerContent = answerContent
        this.answerDate = answerDate
        this.needAnswerFlag = needAnswerFlag
        this.noticeType = noticeType
        this.needFormFlag = needFormFlag
    }
}